<template>
  <div class="schoolBox relative">
    <div class="title">
      <div class="title_left">子食堂（分店、档口）管理</div>
    </div>
    <div v-if="true" style="margin-bottom: 100px;">
      <ToggleForm title="子食堂（分店、档口）维护" :zoomed='true'>
        <div class="innerBox">
          <div class="filtrate">
            <el-input placeholder="请输入子食堂名称、负责人、手机号" class="w300 seekIpt mr20" v-model="queryLimit.keyword" @keyup.enter.native="searchPage">
              <i slot="suffix" class="el-input__icon el-icon-search" @click="searchPage"></i>
            </el-input>
          </div>
          <div class="clear_a">
            <div class="mt20">
              <el-button class="selectHeight mr20" type="primary" @click="openAdd">
                <i style="margin-right: 5px;font-weight: 700;color: #fff;" class="el-icon-plus"></i>新增
              </el-button>
            </div>
          </div>
          <el-divider></el-divider>
          <div class="tabOffTop120">
            <el-table ref="multipleTable" :data="tableData.records" tooltip-effect="dark" style="width: 100%">
              <el-table-column type="index" width="55" label="序号">
                <template slot-scope="scope">
                  {{(queryLimit.size * (queryLimit.current - 1) + scope.$index + 1)}}
                </template>
              </el-table-column>
              <el-table-column  prop="name" min-width="150" label="名称" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{scope.row.name ? scope.row.name  : '-'}}
                </template>
              </el-table-column>
              <el-table-column prop="legalPerson" min-width="150" label="负责人" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{scope.row.legalPerson ? scope.row.legalPerson  : '-'}}
                </template>
              </el-table-column>
              <el-table-column prop="tel" min-width="150" label="手机号" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{scope.row.tel ? scope.row.tel  : '-'}}
                </template>
              </el-table-column>
              <el-table-column prop="remark" min-width="240" label="备注" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{scope.row.remark ? scope.row.remark  : '-'}}
                </template>
              </el-table-column>
              <el-table-column prop="updateTime" min-width="150" label="更新时间" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{scope.row.updateTime ? scope.row.updateTime  : '-'}}
                </template>
              </el-table-column>
              <el-table-column prop="available" min-width="80" label="状态" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{scope.row.available == 0 ? '禁用' : '启用'}}
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="180">  
                <template slot-scope="scope">
                  <a href="javascript:;" class="operate-a" @click="openEdit(scope.row)">编辑</a>
                  <a href="javascript:;" class="operate-a" @click="goEnabled(scope.row, scope.$index)">
                    {{scope.row.available == 0 ? "启用" : "禁用"}}
                  </a>
                  <a href="javascript:;" class="operate-a" @click="delConfirm(scope.row, scope.$index)">删除</a>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="mt20 mb20 rowybUploadText">提示：1，在列表展示、信息公示、录入信息时系统将按照子食堂的更新时间倒序排列，更新时间最近的子食堂将作为默认子食堂。2，最多可添加100个子食堂</div>
          <div class="pagination-box">
            <el-pagination background @size-change="pageSizeChange" @current-change="pageCurrentChange"
                            :current-page="queryLimit.current" :page-sizes="[10, 20, 30, 40,50]" :page-size="queryLimit.size"
                            layout="total,prev, pager, next, sizes, jumper" :total="tableData.total">
            </el-pagination>
          </div>
        </div>
      </ToggleForm>
      <ToggleForm title="子食堂（分店、档口）适用功能模块配置" :zoomed='true'>
        <div class="innerBox options">
          <span>每日菜谱</span>
          <el-select v-model="recipeAvailable" class="ml20 w180" placeholder="请选择状态" @change="recipeChange">
            <el-option v-for="item in availableOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </ToggleForm>
    </div>
    <el-dialog v-if="dialogVisable" class="dialog-div" :close-on-click-modal="false" :modal-append-to-body='false' :title="dialogTitle" :visible.sync="dialogVisable">
      <el-form :model="addForm" :rules="rules" ref="addForm" :inline="true" label-width="100px">
        <el-form-item label="名称" prop="name">
          <el-input class="w200" v-model="addForm.name" maxlength="8" width="200px" placeholder="请输入名称, 8字以内"></el-input>
        </el-form-item>
        <el-form-item label="负责人" prop="legalPerson">
          <el-input class="w200" v-model="addForm.legalPerson" maxlength="15" placeholder="请输入负责人, 15字以内"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="tel">
          <el-input class="w200" v-model="addForm.tel" minlength="11" maxlength="11" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="available">
          <el-select class="w200" v-model="addForm.available" placeholder="请选择启用状态">
            <el-option v-for="(item,index) in availableOptions" :label="item.label" :value="item.value" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input class="remark" v-model="addForm.remark" :autosize="{minRows:6}" type="textarea" maxlength="300" placeholder="请输入备注, 300字以内"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="comfirmAdd('addForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import ToggleForm from "components/ToggleForm";
  import * as api from "api/subCanteen"
  export default {
    name: "subCanteen",
    components: {
      ToggleForm
    },
    data() {
      return {
        queryLimit: {
          current: 1,
          keyword: "",
          size: 10, 
          available: ""
        },
        tableData: [],
        recipeAvailable: 0,
        availableOptions: [{
          label: "禁用",
          value: 0
        }, {
          label: "启用",
          value: 1
        }],
        dialogVisable: false,
        dialogTitle: "添加",
        addForm: {
          name: "",
          legalPerson: "",
          tel: "",
          available: 1,
          remark: ""
        },
        rules: {
          name: [
            {required: true, message: "请输入子食堂名称, 8字以内", trigger: "blur"}
          ],
          tel: [
            {required: false, message: "请输入11位手机号", pattern:/^[1]([3-9])[0-9]{9}$/, trigger: "blur"}
          ],
          available: [
            {required: true, message: "请选择启用状态", trigger: "change"}
          ]
        },
        btn: false
      }
    },
    methods: {
      searchPage(){
        this.queryLimit.current = 1;
        this.getPageData();
      },
      async getPageData(){
        api.getSubCanteenList(this.queryLimit).then(res => {
          if(res.code === 200) {
            this.tableData = res.data
          }
        }).catch(err => {})
      },
      async delConfirm(row, index){
        // 仅剩最后一条数据且为启用状态
        const isLastRow = index === 0 && this.tableData.total === 1 && row.available === 1
        // 多个数据只有一条数据为启用状态
        const isLastAvailable = index === 0 && row.available === 1 && this.tableData.records[1] && this.tableData.records[1].available === 0 && this.queryLimit.current == 1
        if(isLastRow || isLastAvailable) {
          try {
            await this.$confirm('这是最后一个启用状态的子食堂, 删除后所有的功能模块将被禁用, 是否确认删除该子食堂? ', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
            api.delSubCanteen({id: row.id}).then(res => {
              if(res.code === 200) {
                this.$message.success('删除成功!');
                // 更新功能模块的配置(全部禁用)
                this.getModuleConfig();
                this.getPageData();
              } else if(res.code === 4028) {
                this.forceDelSubCanteen(row.id, true, res.msg)
              } else if(res.code === 4029) {
                this.$message.warning(`${res.msg}! 该子食堂不能被删除`)
              }
            }).catch(err => {})
          } catch (e) {
            this.$message({
              type: 'info',
              message: '删除失败'
            });
          }
        } else {
          try {
            // await this.$confirm('是否确认删除该子食堂? ', '提示', {
            //   confirmButtonText: '确定',
            //   cancelButtonText: '取消',
            //   type: 'warning'
            // })
            const h = this.$createElement;
            await this.$msgbox({
              title: '提示',
              message: h('div', null, [
                h('p', null, '是否确认删除该子食堂? '),
                h('p', {class: "ms-ps"}, '注：删除后子食堂所绑定的摄像头全部解绑'),
              ]),
              type: 'warning',
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
            })

            api.delSubCanteen({id: row.id}).then(res => {
              if(res.code === 200) {
                this.$message.success('删除成功!');
                this.getPageData();
              } else if (res.code === 4028) {
                this.forceDelSubCanteen(row.id, true, res.msg)
              } else if(res.code === 4029) {
                this.$message.warning(`${res.msg}! 该子食堂不能被删除`)
              }
            }).catch(err => {})
          } catch (e) {
            this.$message({
              type: 'info',
              message: '删除失败'
            });
          }
        }
      },
      // 强制删除
      async forceDelSubCanteen (id, force, msg){
        try {
          await this.$confirm(`${msg}！是否确定要强制删除?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          api.delSubCanteen({id: id, force: force}).then(res => {
            if(res.code === 200) {
              this.$message.success('删除成功!');
              // 更新功能模块的配置(全部禁用)
              this.getModuleConfig();
              this.getPageData();
            } else {
              this.$message.warning(`${res.msg}! 该子食堂不能被删除`)
            }
          }).catch(err => {})
        } catch (e) {
          this.$message({
            type: 'info',
            message: '删除失败'
          });
        }
      },
      async goEnabled(row, index) {
        // 判断 当第一页的第2条数据状态为禁止时(此时全部数据仅有第一条为启用状态), 禁用第一条时给予提示
        if(index === 0 && row.available === 1 && this.tableData.records[1] && this.tableData.records[1].available === 0 && this.queryLimit.current == 1) {
          try {
            await this.$confirm('这是最后一个启用状态的子食堂, 禁用后所有的功能模块也将被禁用, 是否确认禁用该子食堂?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
            api.enableSubCanteen(0, [row.id]).then(res => {
              if(res.code === 200) {
                this.$message.success('禁用成功');
                // 更新功能模块的配置(全部禁用)
                this.getModuleConfig();
                this.getPageData();
              } else if (res.code === 4028) {
                this.$message.warning(`${res.msg}！请更换默认食堂后再禁用`)
              } else if(res.code === 4029) {
                this.$message.warning(`${res.msg}! 该子食堂不能被禁用`)
              }
            }).catch(err => {})
          } catch (e) {
            this.$message({
              type: 'info',
              message: `${row.available == 0 ? '启用' : '禁用'}失败`
            });
          }
        } else {
          try {
            // await this.$confirm(`是否确认${row.available == 0 ? '启用' : '禁用'}该子食堂?`, '提示', {
            //   confirmButtonText: '确定',
            //   cancelButtonText: '取消',
            //   type: 'warning'
            // })
            const h = this.$createElement;
            await this.$msgbox({
              title: '提示',
              message: h('div', null, [
                h('p', null, `是否确认${row.available == 0 ? '启用' : '禁用'}该子食堂? `),
                row.available == 0? '' : h('p', {class: "ms-ps"}, '注：禁用后子食堂所绑定的摄像头全部解绑'),
              ]),
              type: 'warning',
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
            })
            api.enableSubCanteen(row.available == 0 ? 1 : 0, [row.id]).then(res => {
              if(res.code === 200) {
                this.$message.success(`${row.available == 0 ? '启用' : '禁用'}成功`);
                this.getPageData();
              } else if (res.code === 4028) {
                this.$message.warning(`${res.msg}！请更换默认食堂后再禁用`)
              } else if(res.code === 4029) {
                this.$message.warning(`${res.msg}! 该子食堂不能被禁用`)
              }
            }).catch(err => {})
          } catch (e) {
            this.$message({
              type: 'info',
              message: `${row.available == 0 ? '启用' : '禁用'}失败`
            });
          }
        }
      },
      openEdit(row) {
        this.dialogTitle = "编辑"
        api.getSubCanteenDetail({id: row.id}).then(res => {
          if(res.code === 200) {
            this.addForm = {
              id: res.data.id,
              name: res.data.name,
              legalPerson: res.data.legalPerson,
              tel: res.data.tel,
              available: res.data.available,
              remark: res.data.remark
            }
            this.dialogVisable = true
          }
        }).catch(err => {})
      },
      openAdd(){
        if(this.tableData.total >= 100) {
          this.$message.warning("单个食堂最多添加100个子食堂")
          return
        }
        this.dialogTitle = "添加"
        this.addForm = {
          name: "",
          legalPerson: "",
          tel: "",
          available: 1,
          remark: ""
        }
        this.dialogVisable = true
      },
      pageCurrentChange(current) {
          this.queryLimit.current = current;
          this.getPageData();
      },
      pageSizeChange(size) {
          this.queryLimit.current = 1;
          this.queryLimit.size = size;
          this.getPageData();
      },
      comfirmAdd(addForm) {
        this.$refs[addForm].validate((valid) => {
          if (valid) {
            let subCanteenPromise = this.dialogTitle === "添加" ?
                                    api.addSubCanteen(this.addForm) : 
                                    api.editSubCanteen(this.addForm)
            subCanteenPromise.then(res => {
              if(res.code === 200) {
                this.$message.success(this.dialogTitle === "添加" ? "添加成功" : "编辑成功")
                this.dialogVisable = false
                this.getPageData()
              }
            }).catch(err => {})
          }
        });
      },
      cancel() {
        this.dialogVisable = false
      },
      getModuleConfig() {
        api.findModule().then(res => {
          if(res.code === 200) {
            this.recipeAvailable = res.data.DAILY_RECIPE
          } 
        }).catch(err => {})
      },
      async recipeChange(val) {
        try {
          await this.$confirm(`是否确认${val === 1 ? '启用' : '禁用'}该模块的子食堂功能？`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          api.updateModule({available: val, module: "DAILY_RECIPE"}).then(res => {
            if(res.code === 200) {
              this.$message.success(`${val === 1 ? '启用' : '禁用'}成功`)
            } else {
              this.recipeAvailable = val === 0 ? 1 : 0
            }
          }).catch(err => {})
        } catch (e) {
          this.$message({
            type: 'info',
            message: `${val === 1 ? '启用' : '禁用'}失败`
          });
          this.recipeAvailable = val === 0 ? 1 : 0
        }
      }
    },
    mounted() {
      this.getPageData()
      this.getModuleConfig()
    }
  };
</script>

<style scoped lang='scss'>
  .schoolBox {
    width: calc(100% - 40px);
    height: 100%;
    padding: 0 100px 0px 20px;

    .title {
      height: 60px;
      line-height: 60px;

      .title_left {
        font-size: 20px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        width: 50%;
        height: 100%;
      }
    }
  }

  .innerBox {
    width: calc(100% - 60px);
    padding: 20px 30px;
    height: calc(100% - 125px);
    background: #fff;
    border-radius: 10px;
    .filtrate {
      vertical-align: center;
    }
  }
  .options {
    margin-left: 100px;
    margin-top: 50px;
  }
  .pagination-box {
    text-align: right;
    margin-top: 20px;
  }

  .dialog-div ::v-deep .el-dialog {
    width: 700px;
    .remark {
      width: 510px;
    }
  }
    .ms-ps{
    color: #f00;
    font-size: 14px;
  }

</style>